var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Play_Store_badge_EN",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 64,
    viewBox: "0 0 216 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.472,
    y1: 1.035,
    x2: 2.361,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.95,
    y1: 1.879,
    x2: 1.69,
    y2: 1.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.926,
    y1: 0.946,
    x2: 1.835,
    y2: 0.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.856,
    y1: 2.093,
    x2: 1.897,
    y2: 2.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32283",
    "data-name": "Path 32283",
    d: "M208,64H8a8.024,8.024,0,0,1-8-8V8A8.013,8.013,0,0,1,8,0H208a8.016,8.016,0,0,1,8,8V56A8.026,8.026,0,0,1,208,64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32284",
    "data-name": "Path 32284",
    d: "M208,1.281A6.741,6.741,0,0,1,214.724,8V56A6.729,6.729,0,0,1,208,62.719H8A6.741,6.741,0,0,1,1.276,56V8A6.729,6.729,0,0,1,8,1.281ZM208,0H8A8.024,8.024,0,0,0,0,8V56a8.013,8.013,0,0,0,8,8H208a8.016,8.016,0,0,0,8-8V8A8.026,8.026,0,0,0,208,0Z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32285",
    "data-name": "Path 32285",
    d: "M1702.354,281.646a4.84,4.84,0,0,1-3.62-1.5,5.134,5.134,0,0,1-1.462-3.671,5.02,5.02,0,0,1,1.462-3.667,4.825,4.825,0,0,1,3.616-1.5,4.889,4.889,0,0,1,3.62,1.5,5.329,5.329,0,0,1,0,7.334A4.8,4.8,0,0,1,1702.354,281.646Zm-42.92,0a5.2,5.2,0,0,1-3.636-8.858,4.955,4.955,0,0,1,3.636-1.484,5.048,5.048,0,0,1,2.03.423,4.109,4.109,0,0,1,1.546,1.109l.1.116-1.077,1.061-.111-.132a3.055,3.055,0,0,0-2.5-1.081,3.447,3.447,0,0,0-2.491,1.021,3.89,3.89,0,0,0,0,5.315,3.631,3.631,0,0,0,5.05,0,2.766,2.766,0,0,0,.731-1.664h-3.453V275.98h4.935l.02.136a5.554,5.554,0,0,1,.071.75,4.5,4.5,0,0,1-1.232,3.312A4.8,4.8,0,0,1,1659.434,281.646Zm57.066-.211h-1.522l-4.661-7.489.04,1.349v6.137h-1.522v-9.915h1.737l.048.076,4.383,7.054-.04-1.345v-5.786h1.538Zm-25.582,0h-1.542v-8.427H1686.7v-1.492h6.886v1.492h-2.674v8.427Zm-5.471,0h-1.538v-9.919h1.538Zm-8.643,0h-1.538v-8.427h-2.674v-1.492h6.886v1.492H1676.8Zm-5.186-.016h-5.9v-9.9h5.9v1.492h-4.355v2.721h3.93v1.476h-3.93v2.721h4.355Zm28.245-2.3a3.4,3.4,0,0,0,2.492,1.037,3.31,3.31,0,0,0,2.491-1.037,3.943,3.943,0,0,0,0-5.283,3.4,3.4,0,0,0-2.492-1.037,3.3,3.3,0,0,0-2.487,1.037,3.949,3.949,0,0,0-.008,5.283Z",
    transform: "translate(-1588.564 -260.475)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32286",
    "data-name": "Path 32286",
    d: "M1689.83,690.557a6.807,6.807,0,1,0,6.8,6.807A6.686,6.686,0,0,0,1689.83,690.557Zm0,10.917a4.138,4.138,0,1,1,3.823-4.126A3.932,3.932,0,0,1,1689.83,701.474ZM1675,690.557a6.807,6.807,0,1,0,6.8,6.807A6.686,6.686,0,0,0,1675,690.557Zm0,10.917a4.138,4.138,0,1,1,3.823-4.126A3.932,3.932,0,0,1,1675,701.474Zm-17.651-8.838v2.881h6.886a6.085,6.085,0,0,1-1.558,3.627,7.013,7.013,0,0,1-5.313,2.115,7.682,7.682,0,0,1,0-15.362,7.336,7.336,0,0,1,5.186,2.063l2.034-2.043a9.983,9.983,0,0,0-7.2-2.917,10.562,10.562,0,1,0,0,21.123,9.35,9.35,0,0,0,9.843-9.724,8.932,8.932,0,0,0-.159-1.8h-9.719S1657.346,692.636,1657.346,692.636Zm72.2,2.242a6.3,6.3,0,0,0-5.806-4.337,6.455,6.455,0,0,0-6.39,6.807,6.64,6.64,0,0,0,6.728,6.807,6.723,6.723,0,0,0,5.646-3.02l-2.3-1.548a3.852,3.852,0,0,1-3.33,1.883,3.461,3.461,0,0,1-3.294-2.063l9.064-3.771S1729.543,694.878,1729.543,694.878Zm-9.243,2.274a3.729,3.729,0,0,1,3.541-3.966,2.612,2.612,0,0,1,2.515,1.44Zm-7.363,6.6h2.976v-20h-2.976Zm-4.888-11.679h-.107a4.687,4.687,0,0,0-3.576-1.528,6.808,6.808,0,0,0,0,13.6,4.674,4.674,0,0,0,3.576-1.548h.107v.978c0,2.6-1.383,4-3.612,4a3.759,3.759,0,0,1-3.417-2.418l-2.587,1.085a6.472,6.472,0,0,0,6,4.018c3.489,0,6.445-2.063,6.445-7.094V690.948h-2.814v1.121Zm-3.417,9.4a4.14,4.14,0,0,1,0-8.247c2.034,0,3.612,1.76,3.612,4.142A3.773,3.773,0,0,1,1704.632,701.474Zm38.846-17.724h-7.117v20h2.977v-7.573h4.144a6.22,6.22,0,1,0,0-12.425Zm.087,9.632h-4.232v-6.863h4.232a3.432,3.432,0,1,1,0,6.863Zm18.378-2.861a5.6,5.6,0,0,0-5.313,3.056l2.638,1.1a2.827,2.827,0,0,1,2.71-1.476,2.878,2.878,0,0,1,3.135,2.578v.211a6.646,6.646,0,0,0-3.1-.766c-2.849,0-5.738,1.564-5.738,4.5,0,2.685,2.336,4.409,4.939,4.409a4.185,4.185,0,0,0,3.787-1.955h.107v1.548h2.869v-7.661C1767.98,692.5,1765.342,690.521,1761.944,690.521Zm-.373,10.953c-.974,0-2.337-.479-2.337-1.708,0-1.548,1.7-2.135,3.151-2.135a5.149,5.149,0,0,1,2.71.674A3.588,3.588,0,0,1,1761.571,701.474Zm16.876-10.526-3.417,8.674h-.107l-3.541-8.674h-3.2l5.313,12.126-3.028,6.739h3.1l8.174-18.865Zm-26.791,12.8h2.977v-20h-2.977Z",
    transform: "translate(-1581.266 -655.748)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32287",
    "data-name": "Path 32287",
    d: "M400.827,299.508a3.249,3.249,0,0,0-.727,2.258v35.38a3.093,3.093,0,0,0,.743,2.238l.123.108,19.741-19.822v-.443L400.95,299.4Z",
    transform: "translate(-384.201 -287.454)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32288",
    "data-name": "Path 32288",
    d: "M924.884,644.186l-6.584-6.611v-.463l6.584-6.611.143.088,7.788,4.445c2.229,1.261,2.229,3.344,0,4.62l-7.788,4.445Z",
    transform: "translate(-881.81 -605.343)",
    fill: "url(#linear-gradient-2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32289",
    "data-name": "Path 32289",
    d: "M444.992,808.755,438.264,802,418.4,821.946c.727.782,1.947.87,3.31.108l23.282-13.3",
    transform: "translate(-401.774 -770)",
    fill: "url(#linear-gradient-3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32290",
    "data-name": "Path 32290",
    d: "M444.992,300.295,421.71,287.016c-1.363-.782-2.587-.674-3.31.108l19.864,19.926Z",
    transform: "translate(-401.774 -275.05)",
    fill: "url(#linear-gradient-4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32291",
    "data-name": "Path 32291",
    d: "M445.233,967.7,422.11,980.891c-1.292.746-2.444.694-3.187.016l-.123.124.123.108c.743.674,1.9.73,3.187-.016l23.282-13.279Z",
    transform: "translate(-402.158 -929.089)",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32292",
    "data-name": "Path 32292",
    d: "M1091.451,804.079l-7.951,4.533.143.144,7.788-4.445A2.8,2.8,0,0,0,1093.1,802,2.876,2.876,0,0,1,1091.451,804.079Z",
    transform: "translate(-1040.445 -770)",
    opacity: 0.12
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32293",
    "data-name": "Path 32293",
    d: "M404.137,287.08l31.07,17.724a2.938,2.938,0,0,1,1.665,2.079,2.8,2.8,0,0,0-1.665-2.31l-31.07-17.724c-2.229-1.281-4.037-.211-4.037,2.346v.231C400.1,286.864,401.908,285.815,404.137,287.08Z",
    transform: "translate(-384.201 -274.882)",
    fill: "#fff",
    opacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreBadge);
export default __webpack_public_path__ + "static/media/play_store_badge.28be5eb564f4f4e858c11b14373f69bf.svg";
export { ForwardRef as ReactComponent };